export default __webpack_public_path__ + "static/media/spinner.fc1803f3.svg";